import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'how_many_nationalities_are_represented_among_wrkrs_and_supvs_at'

export const dataPointDefinition = {
  retracedId: 'how_many_nationalities_are_represented_among_wrkrs_and_supvs_at',
  name: 'How many nationalities are represented among workers and supervisors at the facility?',
  description:
    "This question relates to workers and supervisors, and includes the nationalities of local workers/supervisors, as well as all nationalities of foreign migrants.\r\r\n\r\r\nNationality includes the country on a worker's passport/national ID.",
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-nat-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 1910,
  sectionId: '2.2.6.2',
  impactArea: 'Worker Demographics (Languages and Nationalities)',
  impactAreaId: 'WORKER_DEMOGRAPHICS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
